export default function STDEVS() {
  return (
    <div className="p-4">
      <h1>STDEV.S</h1>
    </div>
  );
}
